import { render, staticRenderFns } from "./ServiceCenterViewEstablishments.vue?vue&type=template&id=d5422b2e"
import script from "./ServiceCenterViewEstablishments.vue?vue&type=script&lang=js"
export * from "./ServiceCenterViewEstablishments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports